<div class="">
  <div class="">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Open Route</h4>
      </div>
      <div class="modal-body">
        <strong>Saved Routes</strong>
        <div class="card">
          <div class="card-body">
            <div
              class="d-flex flex-column justify-content-center"
              *ngIf="loading"
            >
              <app-spinner></app-spinner>
            </div>
            <div
              class="alert alert-danger fade show"
              role="alert"
              *ngIf="errorMessage !== ''"
            >
              <i class="material-icons alert-icon">error</i>
              <div>{{ errorMessage }}</div>
              <button type="button" class="close" data-dismiss="alert">
                <i class="modus-icon material-icons">close</i>
              </button>
            </div>

            <div
              class="item-list-container places-container"
              *ngIf="errorMessage === ''"
            >
              <div class="" *ngIf="savedRoutes && savedRoutes.length === 0">
                <div class="message message-secondary">
                  <i class="modus-icons">info</i>No Routes have been saved.
                </div>
              </div>
              <table
                class="table table-hover"
                *ngIf="savedRoutes && savedRoutes.length > 0"
              >
                <thead class="table-secondary">
                  <tr>
                    <th scope="col">Route Name</th>
                    <th scope="col">Origin</th>
                    <th scope="col">Destination</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let route of savedRoutes"
                    tabindex="{{ 300 + $index }}"
                    [ngClass]="{
                      'table-primary': route.Id === selectedRoute?.Id
                    }"
                    (click)="selectRoute(route)"
                    (focus)="selectRoute(route)"
                    (dblclick)="selectRoute(route); openRoute()"
                    (keyup.enter)="selectRoute(route); openRoute()"
                    (mouseenter)="mouseEnter(route)"
                    (mouseleave)="mouseLeave()"
                  >
                    <!-- Need help on table cell width -->
                    <th style="width: 32%" scope="row">
                      <strong>{{ route.Name }}</strong>
                    </th>
                    <td style="width: 32%">
                      <route-dialog-location
                        [location]="route.Stops[0].Location"
                      >
                      </route-dialog-location>
                    </td>
                    <td style="width: 32%">
                      <route-dialog-location
                        [location]="
                          route.Stops[route.Stops.length - 1].Location
                        "
                      >
                      </route-dialog-location>
                    </td>

                    <td class="">
                      <button
                        *ngIf="
                          route.Id === selectedRoute?.Id ||
                          route.Id === mouseOverRouteId
                        "
                        tabindex="-1"
                        class="btn-action btn-sm btn"
                        (click)="
                          deleteRoute(route);
                          $event.preventDefault();
                          $event.stopPropagation()
                        "
                      >
                        <i class="modus-icons">trash</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        *ngIf="errorMessage === ''"
        (click)="openRouteModalRef.hide()"
        class="btn btn-outline-dark"
      >
        Cancel
      </button>
      <button
        *ngIf="errorMessage === ''"
        type="submit"
        [disabled]="!selectedRoute"
        class="btn btn-primary"
        (click)="openRoute()"
      >
        Open
      </button>
      <button
        *ngIf="errorMessage !== ''"
        (click)="openRouteModalRef.hide()"
        class="btn btn-primary"
      >
        OK
      </button>
    </div>
  </div>
</div>
